import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";
import { FONTS, ROUTES } from "../constants";
import { stateType } from "../state";

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		container: {
			backgroundImage:
				"linear-gradient(to right top, #121112, #161016, #1a101b, #1c101f, #1f0f23)",
			height: "40px",
			display: "flex",
			justifyContent: "center",
		},
		item: {
			fontFamily: FONTS,
			fontSize: isMobile ? "12px" : "17px",
			color: "white",
			marginLeft: isMobile ? "10px" : "200px",
			marginTop: "8px",
			cursor: "pointer",
			overflow: isMobile ? "default" : "",
		},
	});
});

export function BottomBar({ state }: stateType) {
	const classes = useStyles();
	return (
		<div className={classes.container}>
			<Link to={ROUTES.privacy} style={{ textDecoration: "none" }}>
				<div className={classes.item} style={{ marginLeft: "0px" }}>
					Privacy Policy
				</div>
			</Link>
			<Link to={ROUTES.legal} style={{ textDecoration: "none" }}>
				<div className={classes.item}>Terms</div>
			</Link>
			<div className={classes.item} onClick={() => window.scrollTo(0, 0)}>
				Back to Top
			</div>
			<div className={classes.item} style={{ cursor: "default" }}>
				© Batch32 Software 2022
			</div>
		</div>
	);
}
